import request from '@/utils/http'
import { getQueryString } from '@/utils/tool'
import type { FilterPayload } from '@/views/common/filtrate/filtrate.type'
// 收藏夹列表统一走收藏模块的 getCustomFoldersApi（含 type=1 默认夹名称处理）
import { getCustomFoldersApi } from '@/views/collect/api'
import { isNull, omitBy } from 'lodash'

/**
 * 根据关键字搜索题目列表
 * @param query 关键字 支持 id 标题 内容
 * @returns
 */
export const searchTopicApi = (
  page: number,
  query: string,
  isReal: any,
  termId?: string,
  type?: number | string
) => {
  return request.get<searchData>('/api/posts/getfuzzy', {
    perPage: 30,
    page: page,
    content: query,
    isReal: isReal,
    termId: termId,
    isFrequency: type === 4 ? 1 : 0
  })
}
export interface searchData {
  total: number
  list: searchList[]
}

export interface searchList {
  id: number
  slugName: string
  categories: number
  hot: number
  title: string
  content: string
  date: number
  examCount: number
  collect: number
  read: number
  like: number
  exam: number
  postNumber: number
  newTopic: number
  updateTopic: number
  questionsId: number
  questionsTypeCode: string
  parentCode: string
  frequency: number
  orderId: number
  practiceCount: number
  /**分类标签 */
  color: number
  /**是否有微课 */
  highfrequencyVideo?: boolean
  listColour: string
  slugDesc?: string
}

/**
 * 根据查询条件获取机经列表
 * @param payload 查询条件
 * @returns
 */
export const getTopicListApi = (payload: FilterPayload) => {
  Object.keys(payload).forEach((item) => {
    const key = item as keyof FilterPayload
    // 剔除不影响筛选条件的参数
    if (!payload[key] || payload[key] === '0') {
      if (key === 'isFull') {
        delete payload.isFull
      }
      if (key === 'code') {
        delete payload.code
      }
      if (key === 'updTopic') {
        delete payload.updTopic
      }
      if (key === 'isReal') {
        delete payload.isReal
      }
    }
  })
  return request.get<TopicListData>('/api/postsV2/list', {
    ...payload
  })
}
export interface TopicListData {
  isReal: number | string
  learnCount: number
  start: number
  pageSize: number
  orderBy: string
  posts: Post[]
  randList: Post[]
  uid: string
  total: number
  hotSort?: any
  practiceStatus?: any
  categories: number
  isFull: number
  updateTopic?: number
  complete: 1 | 0
}

export interface Post {
  id: number
  title: string
  hot: number
  newTopic: number
  updateTopic: number
  practiceCount: number
  date: number
  postModified: number
  exam: number
  read: number
  questionsTypeCode: string
  parentCode: string
  content: string
  postExcerpt: string
  postContentFiltered: string
  color: number
  highfrequencyVideo?: boolean
  questionsId?: number
  complete: 1 | 0
}

/**
 * 获取考试信息
 * @returns
 */
export const getHierarchyApi = () => {
  return request.post<[any[], Countries]>('/api/dynamic/hierarchy')
}
export interface Countries {
  name: string
  list: List3[]
}

interface List3 {
  countries: string
  list: List2[]
}

interface List2 {
  city: string
  list: (List | List)[]
}

interface List {
  id: number
  place: string
}

/**
 * 提交考过信息
 * @param payload
 * @returns
 */
export const postExamedApi = (payload: {
  attribute: 0
  experience: string
  placeId: number | string
  postId: number
  testTime: number
  type: 1
}) => {
  return request.post('/api/posts/examed', { ...payload })
}

export const getExamedPlaceStatsApi = (wpId: number) => {
  return request.get('/api/posts/examedPlaceStats', { wpId })
}

export interface ExamListPayload {
  postId: number
  size: number
  // id: number | string
}

export const getExamListApi = (payload: ExamListPayload) => {
  return request.get('/api/posts/examList', { ...payload })
}

export interface ViewList {
  typeCode: string
  count: number
  hitRate: number
  stabilityRate: number
  highFrequency: number
  proposal: string
  date: string
  newQuestionType: number
  eproposal: string
}

export type CollectLabel = '生词' | '机经' | '精听' | '电台' | '单句'
/**
 * 获取收藏夹信息（复用收藏模块统一接口函数 getCustomFoldersApi，映射为旧版 userCollectTypes 结构）
 * @param label 收藏夹类型
 * @returns
 */
export const getCollectInfoApi = async (label: CollectLabel) => {
  const res = await getCustomFoldersApi(label)
  const list = res.data || []
  return {
    code: res.code,
    data: {
      userCollectTypes: list.map((item) => ({
        id: item.id,
        name: item.name,
        type: item.type ?? 0,
        sort: item.sort ?? 0,
        collectCount: item.collectCount ?? item.total ?? 0,
        label,
        imageUrl: '',
        appImgurl: ''
      })),
      userFavoriteCount: 0
    },
    msg: res.msg
  }
}

export interface UserCollectData {
  userCollectTypes: UserCollectType[]
  userFavoriteCount: number
}

export interface UserCollectType {
  id: number
  label: string
  name: string
  imageUrl: string
  appImgurl: string
  type: number
  userId?: string
  sort: number
  collectCount: number
}

export interface CollectPayload {
  /**收藏夹类型 */
  label: string
  /**收藏夹id */
  id?: number
  /**机经id（v2 兼容字段）；单词收藏时为来源机经 wpId */
  qid?: number
  /**v2 wpId 字段；机经收藏时为练习详情返回的 datas[].id */
  wpId?: number
  /** 收藏夹颜色 */
  color?: number
  /**题型 */
  termName?: string
  word?: string[]
}

/** v2 收藏内容类型 */
export type CollectContentType =
  | 'WORD'
  | 'POST'
  | 'RADIO'
  | 'QUESTION'
  | 'LISTEN_SENTENCE'
  | 'LISTEN_THEME'

/** v2 收藏/取消收藏（toggle）请求参数 */
export interface CollectToggleV2Payload {
  /**统一业务ID；非单词内容可使用 */
  businessId?: number
  /**收藏颜色，默认1 */
  color?: number
  /**内容类型 */
  contentType: CollectContentType
  /**默认或自建收藏夹ID；不传时使用label对应的默认收藏夹 */
  folderId?: number
  /**收藏大类 */
  label: string
  /**精听单句ID；LISTEN_SENTENCE可使用 */
  listenSentenceId?: number
  /**精听主题ID；LISTEN_THEME可使用 */
  listenThemeId?: number
  /**兼容业务ID字段 */
  qid?: number
  /**练习题ID；QUESTION可使用 */
  questionsId?: number
  /**来源机经ID；contentType=WORD时必填 */
  sourceWpId?: number
  /**单词；contentType=WORD时必填 */
  word?: string
  /**机经ID；POST或RADIO可使用 */
  wpId?: number
}

/** 收藏大类 label → v2 contentType 映射（单词单独判断） */
const labelContentTypeMap: Record<string, CollectContentType> = {
  机经: 'POST',
  电台: 'RADIO',
  精听: 'LISTEN_THEME',
  单句: 'LISTEN_SENTENCE'
}

/** 旧版收藏参数 → v2 toggle 参数（qid 对单词即来源机经 wpId，其余即对应业务 id） */
const toCollectToggleV2Payload = (payload: CollectPayload): CollectToggleV2Payload => {
  const v2: CollectToggleV2Payload = {
    label: payload.label,
    folderId: payload.id,
    qid: payload.qid,
    contentType: 'POST'
  }
  // 取消收藏时 color 传 0，v2 接口仅支持 1~4，此时不应携带 color
  if (payload.color) {
    v2.color = payload.color
  }
  if (payload.word?.length) {
    // 单词收藏：qid 传入的是来源机经 wpId
    v2.contentType = 'WORD'
    v2.word = payload.word[0]
    v2.sourceWpId = payload.qid
  } else {
    v2.contentType = labelContentTypeMap[payload.label] ?? 'POST'
    if (v2.contentType === 'POST' || v2.contentType === 'RADIO') {
      // wpId 取机经id；未传时回退 qid（兼容电台等只传单 id 的调用点）
      v2.wpId = payload.wpId ?? payload.qid
    } else if (v2.contentType === 'LISTEN_THEME') {
      v2.listenThemeId = payload.qid
    } else if (v2.contentType === 'LISTEN_SENTENCE') {
      v2.listenSentenceId = payload.qid
    }
  }
  return v2
}

export const postCollectApi = (payload: CollectPayload) => {
  if (payload.color && !payload.id) {
    // 在外部修改颜色（仍走旧接口）
    return request.post('/api/userCollect/updUserCollect', payload)
  }
  // 收藏/取消收藏（v2 toggle）
  return request.post('/api/userCollect/v2/toggle', toCollectToggleV2Payload(payload))
}

/**
 * v2 收藏/取消收藏（toggle）：指定颜色但未传收藏夹 id 的调用点（如高频库书签收藏）也统一走 v2 接口，
 * 不再回落 updUserCollect 旧接口；不传 folderId 即收藏到 label 对应的默认收藏夹
 */
export const postCollectToggleV2Api = (payload: CollectPayload) =>
  request.post('/api/userCollect/v2/toggle', toCollectToggleV2Payload(payload))

interface CommentPayload {
  commentType: number
  content: string | number
  parent: number
  postId: number
  postType: number
  questionsId: number
  syncCommunity: number
  answer?: string | null
  /**1旧 2新  */
  scoreType?: 1 | 2
}
export const reviewAddApi = (payload: CommentPayload) => {
  const source = getQueryString('source') || '机经练习'
  return request.post('/api/questionsComment/add', {
    ...omitBy({ ...payload, scoreType: 2 }, isNull),
    source
  })
}

export interface settingData {
  //刷题模式 0：练习模式 1：看题模式
  brushMode: number
  //练习开始方式 0：自动开始 1：手动开始
  learnStartMode: number
  //准备时间 0：关 1：开
  readinessTime: number
  //自动下一题 0：关 1：开
  autoQuestion: number
  //单词自动发音 0：关 1：开
  wordAutoPronounce: number
  //单词默认发音 0：英音 1：美音
  wordDefaultPronounce: number
  //拼写偏好 0：美式（默认） 1：英式
  spellingPreference: number
}

export interface settingInfoData {
  type: number
  //图片地址
  image: string
  //标题
  title: string
  //描述
  desc: string
}

/**
 * 获取用户学习设置图片
 * @returns
 */
export const getSettingImageApi = () => {
  return request.get<settingInfoData[]>('/api/user/querySettingImage')
}

/**
 * 新增or修改用户学习设置
 * @returns
 */
export const saveOrUpdateSettingApi = (body?: Partial<settingData>) => {
  return request.post<settingData>('/api/user/saveOrUpdateSetting', body)
}

export interface ServerTimeData {
  timestamp: number
  date: string
  datetime: string
  timezone: string
}

/**
 * 获取服务器时间
 */
export const getServerTimeApi = () => {
  return request.get<ServerTimeData>('/api/common/serverTime')
}

export const workTimeOrCountApi = () => {
  let isFind = false
  const fn = {
    /**计数 1次*/
    countFn: () => {
      request.get('/api/postsV2/saveTimedOrCount', {
        type: 2,
        business: 1
      })
    },
    /**计时 秒 */
    countTime: (s: number) => {
      request.get('/api/postsV2/saveTimedOrCount', {
        type: 1,
        business: s
      })
    }
  }
  if (!isFind) {
    if (!window.localStorage.getItem('token')) {
      return {
        countFn: () => {},
        countTime: () => {}
      }
    }
    request
      .get<{
        isCount: boolean
        isSecond: boolean
        isZoom: boolean
      }>('/api/postsV2/findUserWorkCount')
      .then((res) => {
        isFind = true
        if (!res.data.isCount) {
          fn.countFn = () => {}
        }
        if (!res.data.isSecond) {
          fn.countTime = () => {}
        }
        window.localStorage.setItem('isZoom', JSON.stringify(res.data.isZoom || false))
      })
  }
  // type: 1-计时(秒),2-计数
  return fn
}
